import { Button, Stack, Text, Box } from '@chakra-ui/react'
import { useFormik } from 'formik';
import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import * as Yup from 'yup';
import CustomInput from '../../form-components/CustomInput';
import { UseApi } from '../../../libraries/UseApi';
import { UseConstant } from '../../../libraries/UseConstant';

export default function ForgotPasswordForm() {
    const { postApi } = UseApi();
    const { constant } = UseConstant();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('有効なメールアドレスを入力してください').required('メールアドレスは必須です'),
        }),
        onSubmit: (values) => {
            setIsLoading(true);
            postApi(
                `${process.env.REACT_APP_API_URL}/user/forgot-password`, values, {},
                (response) => {
                    setIsLoading(false);
                    if (response.isSuccess === false) {
                        return;
                    }
                    handleResponse(response);
                }
            );
        }
    });

    const handleResponse = (response) => {
        if (response.isSuccess) {
            navigate('/reset-forgot-password', { state: { email: formik.values.email } });
        } else {
            alert(response.message || constant.DEFAULT_ERROR_MESSAGE);
        }
    }

    return (
        <Box
            p={8}
            bg="rgba(255, 255, 255, 0.1)"
            backdropFilter="blur(20px)"
            borderRadius="3xl"
            boxShadow="0 8px 32px 0 rgba(251, 146, 60, 0.15)"
            border="1px solid rgba(255, 255, 255, 0.18)"
            position="relative"
            overflow="hidden"
            _before={{
                content: '""',
                position: 'absolute',
                top: '0',
                left: '0',
                right: '0',
                height: '3px',
                bgGradient: 'linear(to-r, orange.400, pink.400, red.400)',
            }}
        >
            <form onSubmit={formik.handleSubmit}>
                <Stack spacing={5}>
                    <CustomInput
                        formik={formik}
                        label={'メールアドレス'}
                        type={'email'}
                        name={'email'}
                        id={'email'}
                        placeholder={'メールアドレスを入力'}
                        required={true}
                        bg="rgba(255, 255, 255, 0.9)"
                        border="2px solid transparent"
                        _hover={{ 
                            bg: "rgba(255, 255, 255, 1)",
                            borderColor: 'orange.300' 
                        }}
                        _focus={{ 
                            borderColor: 'orange.400',
                            boxShadow: '0 0 0 3px rgba(251, 146, 60, 0.1)',
                            bg: "rgba(255, 255, 255, 1)"
                        }}
                        borderRadius="xl"
                        height="14"
                        fontSize="md"
                        fontWeight="500"
                    />

                    <Stack
                        direction={{ base: 'column', sm: 'row' }}
                        align={'start'}
                        justify={'space-between'}
                    >
                        <Link to={'/sign-in'}>
                            <Text 
                                color={'orange.400'} 
                                fontWeight="600"
                                fontSize="sm"
                                _hover={{ 
                                    color: 'orange.500',
                                    textDecoration: 'underline' 
                                }}
                            >
                                ログインへ戻る
                            </Text>
                        </Link>
                    </Stack>

                    <Button
                        bgGradient="linear(to-r, orange.400, red.500)"
                        color={'white'}
                        size="lg"
                        height="14"
                        fontSize="md"
                        fontWeight="700"
                        letterSpacing="wide"
                        _hover={{
                            bgGradient: 'linear(to-r, orange.500, red.600)',
                            transform: 'scale(1.02)',
                            boxShadow: '0 10px 40px rgba(251, 146, 60, 0.4)',
                        }}
                        _active={{
                            transform: 'scale(0.98)',
                        }}
                        type='submit'
                        isLoading={isLoading}
                        loadingText="送信中..."
                        borderRadius="xl"
                        transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
                        boxShadow="0 4px 20px rgba(251, 146, 60, 0.3)"
                    >
                        送信
                    </Button>
                </Stack>
            </form>
        </Box>
    )
}